import CommponentView from "./ComponentView";

export default CommponentView;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/ComponentView/index.js